import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { faEye, faFont, faBold, faTextWidth, faLanguage } from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: "app-zoom",
  templateUrl: "./zoom.component.html",
  styleUrls: ["./zoom.component.css"]
})
export class ZoomComponent implements OnInit {

  finalizada: boolean = false;
  redirect: boolean = true;

  @ViewChild("puntual") puntual: ElementRef;
  constructor() { }

  ngOnInit(): void {
  }
  faEye = faEye;
  faFont = faFont;
  faTextWidth = faTextWidth;
  faLanguage = faLanguage;
  faBold = faBold;
}
